import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";
import { put } from "@rails/request.js";

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = { url: String, entity: String };

  connect() {
    this.sortable = Sortable.create(this.element, {
      onEnd: this.onEnd.bind(this),
      animation: 150,
      handle: "[data-sortable-handle]",
    });
  }

  disconnect() {
    this.sortable.destroy();
  }

  onEnd(event) {
    const { newIndex, item } = event;
    const id = item.dataset.sortableId;
    const url = this.urlValue.replace(":id", id);

    const entity = this.entityValue;
    const data = { [entity]: { position: newIndex } };

    put(url, {
      body: JSON.stringify(data),
      responseKind: "turbo-stream",
    });
  }
}
